import React from "react";

import type * as WPDS from "../theme";
import { DropdownMenu as ActionMenuPrimitive } from "radix-ui";

//const NAME = "ActionMenuPortal";

export type ActionMenuPortalProps = {
  /** Any React node may be used as a child to allow for formatting */
  children?: React.ReactNode;
  /** Override CSS */
  css?: WPDS.CSS;
} & ActionMenuPrimitive.DropdownMenuPortalProps;

export const ActionMenuPortal = ({
  children,
  ...props
}: ActionMenuPortalProps) => {
  return (
    <ActionMenuPrimitive.Portal {...props}>
      {children}
    </ActionMenuPrimitive.Portal>
  );
};

//ActionMenuPortal.displayName = NAME;
